import { ProductSubscriptionSuccessFeeTier, SuccessFeeTier } from '../models';

export function CalculateScrollbarOffset<TElement extends HTMLElement>(element: TElement | null | undefined): number {
	return (element?.offsetWidth ?? 0) - (element?.clientWidth ?? 0);
}

export function transformSubscriptionSuccessFeeTiers(tiers: ProductSubscriptionSuccessFeeTier[]): SuccessFeeTier[] {
	let list = [] as SuccessFeeTier[];

	tiers.map(tier => {
		list.push({
			guid: tier.guid,
			basisPoints: tier.basisPoints,
			lowerFundingAmount: tier.lowerFundingAmount,
			upperFundingAmount: tier.upperFundingAmount,
			isDefault: true,
		} as SuccessFeeTier);
	});

	return list;
}
